export type NodeEnv = 'staging' | 'production' | 'dev';

export const currentNodeEnv = import.meta.env.VITE_NODE_ENV ?? 'dev';

export const checkAccessEnv = (access: NodeEnv[] = ['staging', 'production', 'dev']): boolean => {
  return access?.includes(currentNodeEnv);
};
